import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { withRouter } from 'react-router-dom'
import { selectConversation } from 'actions/inbox'
import { receiveContact } from 'actions/contacts/addOrEdit'
import { read } from 'actions/data'
import ConversationIcon from 'components/theme/ConversationIcon'
import { toggleDialog } from 'actions/view'

const InboxButton = ({
  inbox,
  inboxKeys,
  history,
  match,
  selectConversation,
  // contact,
  read,
  mobile,
  contactID,
  toggleDialog,
}) => {
  return !inbox && contactID !== 'new' ? (
    <Button
      color="secondary"
      variant="contained"
      size="small"
      style={{ marginTop: 7 }}
      onClick={() => {
        toggleDialog({
          open: false,
          dialog: 'contact',
          options: {},
        })
        read(contactID, 'inbox', 'inbox/conversation', 'contact_id').then(
          payload => {
            Promise.resolve(selectConversation(contactID)).then(() =>
              history.push('/inbox'),
            )
            // .then(() => receiveContact(payload.contact))
          },
        )
      }}
    >
      <ConversationIcon style={{ marginRight: 5 }} />
      Chat
    </Button>
  ) : null
}

export default withRouter(
  connect(
    (state, { match }) => ({
      inboxKeys:
        typeof state.data.inbox === 'object' &&
        Object.keys(state.data.inbox).reduce((acc, el) => {
          acc[el] = true
          return acc
        }, {}),
      contactID: state.addOrEditContact.contactID,
      // contact:
      //   match &&
      //   match.params &&
      //   match.params.contactID &&
      //   state.contacts.contactsWithEmailsByID[match.params.contactID],
    }),
    dispatch =>
      bindActionCreators(
        { selectConversation, receiveContact, read, toggleDialog },
        dispatch,
      ),
  )(InboxButton),
)
